<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ quotaApplication.ooptName }} > {{ $t('Выделение квоты на добычу диких животных') }}</h1>
    <div class="my-organization">
      <div class="create-quota-pg allocate-quota-pg bgw-pdg-20">
        <p v-if="quotaApplication.status" class="status text-center">
          {{ $t('Статус') }}: {{ quotaApplication.status.transName }}
        </p>
        <h4 class="text-center">
          {{ $t("Выделение квоты на добычу диких животных") }} {{ quotaApplication.ooptName }}
        </h4>
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <p>
              {{ $t('Дата') }}: {{ quotaApplication.date }} № {{ quotaApplication.number }}
            </p>
            <p v-if="quotaApplication.stateDuty">
              {{ $t('Госпошлина в сомах') }}: {{ quotaApplication.stateDuty }}
            </p>
          </div>
          <div class="flex-two-col__right">
            <p>{{ $t('Отправитель') }}: {{ quotaApplication.userFio }}</p>
          </div>
        </div>
        <v-form ref="form" @submit.prevent="saveApplicationAllocate" lazy-validation>
          <!--таблица-->
          <div v-if="faunaQuotas" class="form-group">
            <div class="table-overflow">
              <table class="table-full">
                <thead>
                <tr>
                  <td>{{ $t('Вид животного') }}</td>
                  <td class="text-center">{{ $t('Лимит') }}</td>
                  <td class="text-center">{{ $t('Кол-во гол. в заявке') }}</td>
                  <td class="text-center">{{ $t('Кол-во выданных ранее') }}</td>
                  <td class="text-center">{{ $t('Кол-во выданных квот') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(faunaQuota, index) in faunaQuotas" :key="faunaQuota.id">
                  <td>{{ faunaQuota.faunaName }}</td>
                  <td class="text-center">{{ faunaQuota.limitHeadQuantity }}</td>
                  <td class="text-center">{{ faunaQuota.count }}</td>
                  <td class="text-center">{{ faunaQuota.limitHeadQuantityQuota }}</td>
                  <td class="text-center">
                    <v-text-field
                      v-model="faunaQuotas[index].allocatedCount"
                      type="number"
                      outlined
                      dense
                      class="size-small hide-arrows"
                      min="1"
                      @change="faunaAllocateQuotaHandler(true)"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--Вход. номер - Дата получения-->
          <div class="form-group">
            <div class="quota-fields justify-space-between">
              <div class="quota-field" :class="{ invalid: $v.quotaApplication.incomingNumber.$error }">
                <label>{{ $t('Вход. номер') }}:</label>
                <v-text-field
                  v-model="quotaApplication.incomingNumber"
                  outlined
                  dense
                  class="size-small"
                />
              </div>
              <div class="quota-field datepicker-main" :class="{ invalid: $v.quotaApplication.incomingDate.$error }">
                <label>{{ $t('Дата получения') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    v-model="quotaApplication.incomingDate"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="$t('Дата')"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--Реквизиты документа - Дата обработки-->
          <div class="form-group">
            <div class="quota-fields justify-space-between">
              <div class="quota-field textarea-field" :class="{ invalid: $v.quotaApplication.documentsDetails.$error }">
                <label>{{ $t('Реквизиты документа') }}:</label>
                <v-textarea
                  v-model="quotaApplication.documentsDetails"
                  outlined
                  dense
                  class="size-small"
                />
              </div>
              <div class="quota-field datepicker-main" :class="{ invalid: $v.quotaApplication.processingDate.$error }">
                <label>{{ $t('Дата обработки') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    v-model="quotaApplication.processingDate"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="$t('Дата')"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--Файл-->
          <div class="form-group" :class="{ invalid: $v.quotaAllocateFile.$error }">
            <div class="quota-field" v-if="quotaApplication.answerFile">
              <template
                v-if="checkFileExist(quotaApplication.answerFileExtension)"
              >
                <a
                  @click="previewDocumentDialog(quotaApplication.id, true)"
                >{{ $t('Файл ответа') }}</a>
                <v-dialog
                  v-model="previewDocsModal[quotaApplication.id]"
                  max-width="1200"
                >
                  <v-card class="modal">
                    <div class="modal-head">
                      {{ $t('Файл ответа') }}
                      <v-btn
                        color="modal-close"
                        @click="previewDocumentDialog(quotaApplication.id, false)"
                      >
                        <img src="@/assets/img/close-icon.png" alt="icon">
                      </v-btn>
                    </div>
                    <div class="modal-body">
<!--                      <iframe :src="'https://docs.google.com/viewer?embedded=true&url='+backUrl + quotaApplication.answerFile" frameborder="no" style="width:100%;height:160px"></iframe>-->
                      <VueDocPreview
                        :value="backUrl + quotaApplication.answerFile"
                        type="office"
                      />
                    </div>
                  </v-card>
                </v-dialog>
              </template>
              <template v-else>
                <a
                  :href="backUrl + quotaApplication.answerFile"
                  target="_blank"
                >{{ $t('Файл ответа') }}</a>
              </template>
            </div>
            <div class="file-input-link upload-file">
              <v-file-input
                :label="$t('Загрузить файл документа')"
                v-model="quotaAllocateFile"
                clearable
                ref="file"
                @change="handleFileUpload()"
                :error="$v.quotaAllocateFile.$error"
              />
            </div>
          </div>
          <div class="form-action">
            <button
              class="btn btn-default blue"
              type="submit"
            >
              {{ $t('Сохранить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Quota from '@/model/quota'
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
import VueDocPreview from 'vue-doc-preview'

export default {
  components: {
    VueDocPreview
  },
  data: () => ({
    breadcrumbs: [],
    quotaApplication: {},
    faunaQuotas: [],
    history: {},
    isSpecialist: false,
    file: '',
    quotaAllocateFile: null,
    backUrl: process.env.VUE_APP_BACK_URL,
    previewDocsModal: [],
    rules: {
      quotaApplication: {
        incomingNumber: { required },
        incomingDate: { required },
        documentsDetails: { required },
        processingDate: { required }
      },
      quotaAllocateFile: {
        required: requiredIf(function () {
          return this.quotaApplication.answerFile === null
        })
      }
    }
  }),
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.showQuotaApplication(this.$route.params.id).then((response) => {
        this.quotaApplication = response.data.quotaApplication
        this.history = response.data.lastHistory
        this.isSpecialist = response.data.isSpecialist
        this.faunaQuotas = this.quotaApplication.faunaQuotas
        // если нет "Дата получения", то по умолчанию ставим текущую дату
        if (this.quotaApplication.incomingDate == null) {
          this.quotaApplication.incomingDate = moment(new Date()).format('DD.MM.YYYY')
        }
        this.generateBreadcrumbs()
        this.scrollToTop()
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на квоты'),
          disabled: false,
          href: '/quota-applications'
        },
        {
          text: this.$i18n.t('Выделение квоты на добычу животных'),
          disabled: true
        }
      ]
    },
    // проверяем на ввод ("Кол-во выданных квот" не должно превышать "кол-во гол.в заявке")
    faunaAllocateQuotaHandler (withMsg = true) {
      this.faunaQuotas.forEach((element) => {
        if (element.allocatedCount > element.count) {
          element.allocatedCount = element.count
          if (withMsg === true) {
            this.$noty.error(this.$i18n.t('Количество выданных квот не должно превышать, количество голов в заявке'), {
              killer: true,
              timeout: 2000,
              layout: 'topRight'
            })
          }
        }
        if (element.allocatedCount <= 0) {
          element.allocatedCount = 1
          if (withMsg === true) {
            this.$noty.error(this.$i18n.t('Количество выданных квот должно быть больше 0'), {
              killer: true,
              timeout: 2000,
              layout: 'topRight'
            })
          }
        }
      })
    },
    // Сохранение
    saveApplicationAllocate () {
      if (!this.validateForm()) {
        return
      }
      this.faunaAllocateQuotaHandler(false)

      this.setLoading(true)

      const formEl = this.$refs.form.$el
      const fd = new FormData(formEl)
      fd.append('quota_application_allocate[incomingNumber]', this.quotaApplication.incomingNumber)
      fd.append('quota_application_allocate[incomingDate]', this.quotaApplication.incomingDate)
      fd.append('quota_application_allocate[processingDate]', this.quotaApplication.processingDate)
      fd.append('quota_application_allocate[documentDetails]', this.quotaApplication.documentsDetails)
      fd.append('quota_application_allocate[uploadedFile]', this.quotaAllocateFile)
      const result = []
      this.faunaQuotas.map(element => {
        result.push({
          id: element.id,
          count: element.allocatedCount
        })
      })
      result.forEach(function (element, index) {
        fd.append('faunaQuotas[' + index + '][id]', element.id)
        fd.append('faunaQuotas[' + index + '][count]', element.count)
      })

      Quota.createAllocateQuotas(this.$route.params.id, fd).then((response) => {
        this.$router.push({
          name: 'quota-view',
          params: {
            id: this.$route.params.id
          }
        })
        this.setLoading(false)
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        this.setLoading(false)
      })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    handleFileUpload () {
      this.file = ''

      if (this.quotaAllocateFile) {
        this.createFile(this.quotaAllocateFile)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'quota-view',
        params: {
          id: this.$route.params.id
        }
      })
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    }
  }
}
</script>

<style lang="scss" scoped>
  table {
    td {
      .v-input {
        margin: 0 auto;
      }
    }
  }
</style>
